/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AllocationComment } from '@coin/shared/core/util-models-v2';
import { AllocationSettings } from '@coin/shared/core/util-models-v2';
import { AllocationWorkflow } from '@coin/shared/core/util-models-v2';
import { AutoFinalize } from '@coin/shared/core/util-models-v2';
import { ChangeAllocationManager } from '@coin/shared/core/util-models-v2';
import { ChangeManyPriorities } from '@coin/shared/core/util-models-v2';
import { CreateAllocationComment } from '@coin/shared/core/util-models-v2';
import { CreateAllocationSettings } from '@coin/shared/core/util-models-v2';
import { CreateAllocationWorkflow } from '@coin/shared/core/util-models-v2';
import { CreateEquitySettings } from '@coin/shared/core/util-models-v2';
import { CreateEquitySubSettings } from '@coin/shared/core/util-models-v2';
import { CreateIndividualMultiplierSettings } from '@coin/shared/core/util-models-v2';
import { CreateMeritExport } from '@coin/shared/core/util-models-v2';
import { CreateMeritHistoryResults } from '@coin/shared/core/util-models-v2';
import { CreateMeritIncentiveSettings } from '@coin/shared/core/util-models-v2';
import { CreateMeritIncentiveSubSettings } from '@coin/shared/core/util-models-v2';
import { CreateMeritPayrollExport } from '@coin/shared/core/util-models-v2';
import { CreateMeritSettings } from '@coin/shared/core/util-models-v2';
import { CreateOrReplaceIndividualAllocationValue } from '@coin/shared/core/util-models-v2';
import { EditAllocatedMember } from '@coin/shared/core/util-models-v2';
import { EquitySettingsModel } from '@coin/shared/core/util-models-v2';
import { EquitySubSettingsModel } from '@coin/shared/core/util-models-v2';
import { ExtendedAllocationMember } from '@coin/shared/core/util-models-v2';
import { IndividualAllocationValueModel } from '@coin/shared/core/util-models-v2';
import { IndividualMeritValueDownload } from '@coin/shared/core/util-models-v2';
import { IndividualMultiplierSettingsModel } from '@coin/shared/core/util-models-v2';
import { MeritAllocationMember } from '@coin/shared/core/util-models-v2';
import { MeritAllocationOverview } from '@coin/shared/core/util-models-v2';
import { MeritEmployeePromotion } from '@coin/shared/core/util-models-v2';
import { MeritIncentiveSettingsModel } from '@coin/shared/core/util-models-v2';
import { MeritIncentiveSubSettingsModel } from '@coin/shared/core/util-models-v2';
import { MeritOrganisationUploadInfo } from '@coin/shared/core/util-models-v2';
import { MeritPromotionDateSettingModel } from '@coin/shared/core/util-models-v2';
import { MeritRecordsUpdateManyRecords } from '@coin/shared/core/util-models-v2';
import { MeritResponsiblePromotionApprover } from '@coin/shared/core/util-models-v2';
import { MeritSimulationSettings } from '@coin/shared/core/util-models-v2';
import { MeritSingleCalculationCommand } from '@coin/shared/core/util-models-v2';
import { PageOfAllocationSeason } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfEquitySettings } from '@coin/shared/core/util-models-v2';
import { PageOfIndividualMultiplierSettings } from '@coin/shared/core/util-models-v2';
import { PageOfMeritAllocationMember } from '@coin/shared/core/util-models-v2';
import { PageOfMeritIncentiveSettings } from '@coin/shared/core/util-models-v2';
import { PageOfMeritRecord } from '@coin/shared/core/util-models-v2';
import { PageOfMeritSimulationSettings } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PromoteEmployee } from '@coin/shared/core/util-models-v2';
import { PromotionBudgetOverview } from '@coin/shared/core/util-models-v2';
import { PromotionBudgetResult } from '@coin/shared/core/util-models-v2';
import { RecalculateAllocationWorkflow } from '@coin/shared/core/util-models-v2';
import { ResumeOrPauseMeritSeason } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { SetFlagForAllocationMember } from '@coin/shared/core/util-models-v2';
import { SetPromotionDateSettingsCommand } from '@coin/shared/core/util-models-v2';
import { SetWasPromotedForAllocationMember } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfAllocationWorkflowRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfCompensationOverlayTransferMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfIMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfMercerDataTransferMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfMeritResultsHistoryMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfNewHireTotalProcessMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfRecordUpdateBatchMetadata } from '@coin/shared/core/util-models-v2';
import { TriggerNewHireProcess } from '@coin/shared/core/util-models-v2';
import { UpdateAllocationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateAllocationWorkflow } from '@coin/shared/core/util-models-v2';
import { UpdateEquitySettings } from '@coin/shared/core/util-models-v2';
import { UpdateEquitySubSettings } from '@coin/shared/core/util-models-v2';
import { UpdateEquitySubSettingsEquityType } from '@coin/shared/core/util-models-v2';
import { UpdateIndividualMultiplierSettings } from '@coin/shared/core/util-models-v2';
import { UpdateMeritIncentiveSettings } from '@coin/shared/core/util-models-v2';
import { UpdateMeritIncentiveSubSettings } from '@coin/shared/core/util-models-v2';
import { UpdateMeritSettings } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface ApproveEmployeeAllocationMembersParams {
  seasonId: string;
  employeeId: string;
}

export interface AutoFinalizeAllocationsAllocationsParams {
  seasonId: string;
  targetProperty?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerGid?: Array<string>;
  companyManagerGid?: Array<string>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerLastName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  templateName?: Array<string>;
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  exportedAt?: string;
  exportedAtMax?: string;
  isOtpOnly?: boolean;
  hasPreset?: boolean;
  autoFinalize?: AutoFinalize;
}

export interface ChangeAllocationManagerAllocationMembersParams {
  seasonId: string;
  employeeId: string;
  changeAllocationManager?: ChangeAllocationManager;
}

export interface ChangePrioritiesAllocationWorkflowsParams {
  changeManyPriorities?: ChangeManyPriorities;
}

export interface ChangePrioritiesEquitySettingsParams {
  simulationId: string;
  changeManyPriorities?: ChangeManyPriorities;
}

export interface ChangePrioritiesEquitySubSettingsParams {
  simulationId: string;
  changeManyPriorities?: ChangeManyPriorities;
}

export interface ChangePrioritiesIndividualMultiplierSettingsParams {
  simulationId: string;
  changeManyPriorities?: ChangeManyPriorities;
}

export interface ChangePrioritiesMeritIncentiveSettingsParams {
  simulationId: string;
  changeManyPriorities?: ChangeManyPriorities;
}

export interface ChangePrioritiesMeritIncentiveSubSettingsParams {
  simulationId: string;
  changeManyPriorities?: ChangeManyPriorities;
}

export interface ChangePrioritiesSettingsParams {
  simulationId: string;
  changeManyPriorities?: ChangeManyPriorities;
}

export interface CreateAllocationMemberCommentsParams {
  seasonId: string;
  employeeId: string;
  createAllocationComment?: CreateAllocationComment;
}

export interface CreateAllocationSettingsAllocationSettingsParams {
  seasonId: string;
  createAllocationSettings?: CreateAllocationSettings;
}

export interface CreateAllocationWorkflowsParams {
  createAllocationWorkflow?: CreateAllocationWorkflow;
}

export interface CreateEquitySettingsParams {
  simulationId: string;
  createEquitySettings?: CreateEquitySettings;
}

export interface CreateEquitySubSettingsParams {
  simulationId: string;
  createEquitySubSettings?: CreateEquitySubSettings;
}

export interface CreateIndividualMultiplierSettingsParams {
  simulationId: string;
  createIndividualMultiplierSettings?: CreateIndividualMultiplierSettings;
}

export interface CreateMeritIncentiveSettingsParams {
  simulationId: string;
  createMeritIncentiveSettings?: CreateMeritIncentiveSettings;
}

export interface CreateMeritIncentiveSubSettingsParams {
  simulationId: string;
  createMeritIncentiveSubSettings?: CreateMeritIncentiveSubSettings;
}

export interface CreateMeritLetterZipMeritLetterZipParams {
  /** Season of the records */
  seasonId: string;
  queryId?: Array<string>;
  queryGid?: Array<string>;
  queryFirstName?: Array<string>;
  queryLastName?: Array<string>;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanName?: Array<string>;
  queryState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryStartDate?: string;
  queryEndDate?: string;
  queryPayoutDate?: string;
  queryAssignmentManager?: string;
  queryAssignmentId?: string;
  queryLetterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  queryProcessStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  queryRecordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  queryWorkflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryTemplate?: Array<string>;
  queryIsDesignReady?: boolean;
  queryPayoutState?: Array<
    'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'
  >;
  queryManagerSetMercerJobCode?: Array<string>;
  queryEditedMercerJobCode?: Array<string>;
  queryCurrentMercerJobCode?: Array<string>;
  queryIsMercerJobCodeValid?: boolean;
  queryIsGripCodeValid?: boolean;
  queryLineManagerName?: string;
  queryLineManagerGid?: Array<string>;
  querySeasonId?: string;
  queryWorkflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  queryMultiplier?: number;
  queryOverallTargetAchievement?: number;
  queryPayoutAmount?: number;
  queryPayoutCurrency?: Array<string>;
  queryIppAchievementValue?: string;
  queryIncentivePaymentType?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** Rule set Model */
  ruleSet?: RuleSet;
}

export interface CreatePromotionDateSettingPromotionSettingParams {
  seasonId: string;
  setPromotionDateSettingsCommand?: SetPromotionDateSettingsCommand;
}

export interface DeleteOrganisationUploadsParams {
  seasonId: string;
}

export interface DisableEmployeeAllocationMembersParams {
  seasonId: string;
  employeeId: string;
}

export interface EditAllocatedMemberRecordsParams {
  seasonId: string;
  employeeId: string;
  editAllocatedMember?: EditAllocatedMember;
}

export interface ExportEmployeeAssignmentsSeasonsParams {
  seasonId: string;
  createMeritExport?: CreateMeritExport;
}

export interface ExportMeritEmployeeDataSeasonsParams {
  seasonId: string;
  createMeritExport?: CreateMeritExport;
}

export interface ExportMeritSimulationMemberTagsSimulationMembersParams {
  simulationId: string;
}

export interface ExportMidYearIncreaseSimulationMembersParams {
  simulationId: string;
}

export interface ExportMultiplierDifferentiationDataSeasonsParams {
  seasonId: string;
}

export interface ExportOrganisationUploadsParams {
  seasonId: string;
  fileName?: string;
}

export interface ExportPayGapCountryDataSeasonsParams {
  seasonId: string;
}

export interface ExportPayGapEmployeeDataSeasonsParams {
  seasonId: string;
}

export interface FlagEmployeeAllocationMembersParams {
  allocationMemberId: string;
  seasonId: string;
  setFlagForAllocationMember?: SetFlagForAllocationMember;
}

export interface GetAllocationMemberRecordsParams {
  seasonId: string;
  employeeId: string;
}

export interface GetAllocationSettingsForSeasonAllocationSettingsParams {
  seasonId: string;
}

export interface GetAllocationTotalsParams {
  seasonId: string;
  employeeId: string;
  impersonatedEmployee?: string;
  orgCode?: string;
}

export interface GetByIdAllocationSettingsParams {
  id: string;
  seasonId: string;
}

export interface GetDirectsAllocationDirectsParams {
  seasonId: string;
  impersonatedEmployee?: string;
  employees?: Array<string>;
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  queryTargetTypeString?: string;
  queryMeritPopulation?: Array<string>;
  queryEquityPopulation?: Array<string>;
  queryManagementGroup?: Array<string>;
  queryPositionClass?: Array<string>;
  queryMercerJobCode?: Array<string>;
  queryOrgCluster?: Array<string>;
  queryOrgClusterNode?: Array<string>;
  queryGeoCluster?: Array<string>;
  queryGeoClusterNode?: Array<string>;
  queryCountry?: Array<string>;
  queryGid?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryContractStatus?: Array<string>;
  queryAre?: Array<string>;
  queryWorkflow?: Array<string>;
  queryIsFlagged?: boolean;
  queryIsMeritExcluded?: boolean;
  queryIsIncentiveExcluded?: boolean;
  queryIsEquityExcluded?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface GetDirectsFieldValuesAllocationDirectsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
  isMeritExcluded?: boolean;
  isEquityExcluded?: boolean;
  promotion?: Array<string>;
  newHire?: Array<string>;
  manuallyChanged?: Array<string>;
  termination?: Array<string>;
  populationChange?: Array<string>;
  equityPopulation?: Array<string>;
  meritPopulation?: Array<string>;
  workflow?: Array<string>;
  are?: Array<string>;
  contractStatus?: Array<number>;
  country?: Array<string>;
  countryInverted?: Array<string>;
  geoCluster?: Array<string>;
  geoClusterNode?: Array<string>;
  managementGroup?: Array<string>;
  gid?: Array<string>;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: string;
  mercerJobCode?: Array<string>;
  orgCluster?: Array<string>;
  orgClusterNode?: Array<string>;
  positionClass?: Array<number>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  individualMultiplier?: Array<'Open' | 'Edited' | 'Finalized' | 'AutoFinalized' | 'AutoFinalizedOpen'>;
  individualAllocationValueIsDone?: boolean;
  page?: number;
  size?: number;
  impersonatedEmployee?: string;
}

export interface GetDirectsOverviewAllocationDirectsParams {
  seasonId: string;
  impersonatedEmployee?: string;
}

export interface GetDownloadBySettingSimulationMembersParams {
  meritSettingsId: string;
}

export interface GetEmployeePromotionAllocationMembersParams {
  seasonId: string;
  employeeId: string;
}

export interface GetInfoOrganisationUploadsParams {
  seasonId: string;
}

export interface GetPayrollExportByListRecordsParams {
  seasonId: string;
  targetProperty?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerGid?: Array<string>;
  companyManagerGid?: Array<string>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerLastName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  templateName?: Array<string>;
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  exportedAt?: string;
  exportedAtMax?: string;
  isOtpOnly?: boolean;
  hasPreset?: boolean;
  createMeritPayrollExport?: CreateMeritPayrollExport;
}

export interface GetPromotionBudgetsAllocationPromotionBudgetsParams {
  seasonId: string;
  impersonatedEmployee?: string;
  orgCode?: string;
}

export interface GetPromotionDateSettingPromotionSettingParams {
  seasonId: string;
}

export interface GetPromotionsOverviewAllocationPromotionBudgetsParams {
  seasonId: string;
  impersonatedEmployee?: string;
  orgCode?: string;
}

export interface GetResponsiblePromotionApproverAllocationMembersParams {
  seasonId: string;
  employeeId: string;
}

export interface GetSeasonsForAllocationAllocationsParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface GetTaskForSimulationMemberAllocationMembersParams {
  seasonId: string;
  employeeId: string;
}

export interface GetTasksTotalOverviewAllocationTotalsParams {
  seasonId: string;
  employeeId: string;
  orgCode?: string;
  impersonatedEmployee?: string;
}

export interface GetTotalOverviewAllocationTotalsParams {
  seasonId: string;
  employeeId: string;
  impersonatedEmployee?: string;
  orgCode?: string;
}

export interface GetTotalsFieldValuesAllocationTotalsParams {
  seasonId: string;
  parentOrgCode?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
  isMeritExcluded?: boolean;
  isEquityExcluded?: boolean;
  promotion?: Array<string>;
  newHire?: Array<string>;
  manuallyChanged?: Array<string>;
  termination?: Array<string>;
  populationChange?: Array<string>;
  equityPopulation?: Array<string>;
  meritPopulation?: Array<string>;
  workflow?: Array<string>;
  are?: Array<string>;
  contractStatus?: Array<number>;
  country?: Array<string>;
  countryInverted?: Array<string>;
  geoCluster?: Array<string>;
  geoClusterNode?: Array<string>;
  managementGroup?: Array<string>;
  gid?: Array<string>;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: string;
  mercerJobCode?: Array<string>;
  orgCluster?: Array<string>;
  orgClusterNode?: Array<string>;
  positionClass?: Array<number>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  individualMultiplier?: Array<'Open' | 'Edited' | 'Finalized' | 'AutoFinalized' | 'AutoFinalizedOpen'>;
  individualAllocationValueIsDone?: boolean;
  page?: number;
  size?: number;
  impersonatedEmployee?: string;
}

export interface HistorizeHistorizationParams {
  seasonId: string;
  targetProperty?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerGid?: Array<string>;
  companyManagerGid?: Array<string>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerLastName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  templateName?: Array<string>;
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  exportedAt?: string;
  exportedAtMax?: string;
  isOtpOnly?: boolean;
  hasPreset?: boolean;
  createMeritHistoryResults?: CreateMeritHistoryResults;
}

export interface MeritAdminCreateSettingsParams {
  simulationId: string;
  createMeritSettings?: CreateMeritSettings;
}

export interface MeritAdminQueryFieldValuesRecordsParams {
  seasonId: string;
  targetProperty?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerGid?: Array<string>;
  companyManagerGid?: Array<string>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerLastName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  templateName?: Array<string>;
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  exportedAt?: string;
  exportedAtMax?: string;
  isOtpOnly?: boolean;
  hasPreset?: boolean;
  page?: number;
  size?: number;
}

export interface MeritAdminQueryFieldValuesSettingsParams {
  simulationId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  targetTypeString?: string;
  simulationId2?: string;
  priority?: number;
  title?: string;
  fixedAllocationPercentage?: number;
  fixedAllocationTotal?: number;
  fixedAllocationCurrency?: string;
  flexibleAllocationPercentage?: number;
  minimumIncreasePercentage?: number;
  minimumIncreaseTotal?: number;
  minimumIncreaseCurrency?: string;
  unrestrictedBudgetPercentage?: number;
  effectiveDateMeritAt?: string;
  effectiveDateIncentiveAt?: string;
  effectiveDateOTPAt?: string;
  isPopulationExcluded?: boolean;
  affectedCount?: number;
  type?: 'General' | 'Default';
  alreadyGrantedIncreaseCurrency?: string;
  page?: number;
  size?: number;
}

export interface MeritAdminQueryRecordsParams {
  seasonId: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryTargetProperty?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38;
  queryGid?: Array<string>;
  queryFirstName?: Array<string>;
  queryLastName?: Array<string>;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  queryMeritTitle?: Array<string>;
  queryEquityTitle?: Array<string>;
  queryEquitySubTitle?: Array<string>;
  queryManuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  queryNewHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  queryPromotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  queryTermination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  queryPopulationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  queryLineManagerGid?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryLineManagerFirstName?: Array<string>;
  queryLineManagerLastName?: Array<string>;
  queryCompanyManagerFirstName?: Array<string>;
  queryCompanyManagerLastName?: Array<string>;
  queryState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryTemplateName?: Array<string>;
  queryTemplateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  queryWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryAutoApprove?: boolean;
  queryApprovalRequired?: boolean;
  queryLetterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryProcessState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryExportState?: Array<'Open' | 'Done'>;
  queryPayrollState?: Array<'Open' | 'Done'>;
  queryMeritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryEquityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryHasOtpIncrease?: boolean;
  queryApprovedByCompanyManager?: boolean;
  queryAllocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryReadyToPayroll?: boolean;
  queryExportedAt?: string;
  queryExportedAtMax?: string;
  queryIsOtpOnly?: boolean;
  queryHasPreset?: boolean;
}

export interface MeritAdminQuerySettingsParams {
  simulationId: string;
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  queryTargetTypeString?: string;
  querySimulationId?: string;
  queryPriority?: number;
  queryTitle?: string;
  queryFixedAllocationPercentage?: number;
  queryFixedAllocationTotal?: number;
  queryFixedAllocationCurrency?: string;
  queryFlexibleAllocationPercentage?: number;
  queryMinimumIncreasePercentage?: number;
  queryMinimumIncreaseTotal?: number;
  queryMinimumIncreaseCurrency?: string;
  queryUnrestrictedBudgetPercentage?: number;
  queryEffectiveDateMeritAt?: string;
  queryEffectiveDateIncentiveAt?: string;
  queryEffectiveDateOTPAt?: string;
  queryIsPopulationExcluded?: boolean;
  queryAffectedCount?: number;
  queryType?: 'General' | 'Default';
  queryAlreadyGrantedIncreaseCurrency?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface MeritAdminUpdateAllocationValuesAllocationsParams {
  seasonId: string;
  employeeId: string;
  createOrReplaceIndividualAllocationValue?: CreateOrReplaceIndividualAllocationValue;
}

export interface MeritAdminUpdateManyRecordsParams {
  seasonId: string;
  targetProperty?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerGid?: Array<string>;
  companyManagerGid?: Array<string>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerLastName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  templateName?: Array<string>;
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  exportedAt?: string;
  exportedAtMax?: string;
  isOtpOnly?: boolean;
  hasPreset?: boolean;
  meritRecordsUpdateManyRecords?: MeritRecordsUpdateManyRecords;
}

export interface MeritAdminUpdateSettingsParams {
  meritSettingsId: string;
  simulationId: string;
  updateMeritSettings?: UpdateMeritSettings;
}

export interface PauseOrResumeMeritSeasonSeasonsParams {
  seasonId: string;
  action?: 'Pause' | 'Resume';
  resumeOrPauseMeritSeason?: ResumeOrPauseMeritSeason;
}

export interface PromoteEmployeeAllocationMembersParams {
  seasonId: string;
  employeeId: string;
  promoteEmployee?: PromoteEmployee;
}

export interface QueryAllocationMemberCommentsParams {
  seasonId: string;
  employeeId: string;
}

export interface QueryEquitySettingsParams {
  simulationId: string;
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  queryTargetTypeString?: string;
  querySimulationId?: string;
  queryPriority?: number;
  queryTitle?: string;
  queryDescription?: string;
  queryIsPopulationExcluded?: boolean;
  queryAffectedCount?: number;
  queryType?: 'General' | 'Default';
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface QueryEquitySubSettingsParams {
  equitySettingsId: string;
  simulationId: string;
}

export interface QueryFieldValuesEquitySettingsParams {
  simulationId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  targetTypeString?: string;
  simulationId2?: string;
  priority?: number;
  title?: string;
  description?: string;
  isPopulationExcluded?: boolean;
  affectedCount?: number;
  type?: 'General' | 'Default';
  page?: number;
  size?: number;
}

export interface QueryFieldValuesIndividualMultiplierSettingsParams {
  simulationId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  targetTypeString?: string;
  simulationId2?: string;
  priority?: number;
  title?: string;
  description?: string;
  affectedCount?: number;
  type?: 'General' | 'Default';
  isExcluded?: boolean;
  isEditable?: boolean;
  page?: number;
  size?: number;
}

export interface QueryFieldValuesMeritIncentiveSettingsParams {
  simulationId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5;
  targetTypeString?: string;
  simulationId2?: string;
  priority?: number;
  title?: string;
  description?: string;
  isPopulationExcluded?: boolean;
  affectedCount?: number;
  type?: 'General' | 'Default';
  page?: number;
  size?: number;
}

export interface QueryIndividualMultiplierSettingsParams {
  simulationId: string;
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  queryTargetTypeString?: string;
  querySimulationId?: string;
  queryPriority?: number;
  queryTitle?: string;
  queryDescription?: string;
  queryAffectedCount?: number;
  queryType?: 'General' | 'Default';
  queryIsExcluded?: boolean;
  queryIsEditable?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface QueryMeritIncentiveSettingsParams {
  simulationId: string;
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5;
  queryTargetTypeString?: string;
  querySimulationId?: string;
  queryPriority?: number;
  queryTitle?: string;
  queryDescription?: string;
  queryIsPopulationExcluded?: boolean;
  queryAffectedCount?: number;
  queryType?: 'General' | 'Default';
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface QueryMeritIncentiveSubSettingsParams {
  incentiveSettingsId: string;
  simulationId: string;
}

export interface QueryTotalViewAllocationTotalsParams {
  seasonId: string;
  priorityEmployeeId?: string;
  parentOrgCode?: string;
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  queryTargetTypeString?: string;
  queryMeritPopulation?: Array<string>;
  queryEquityPopulation?: Array<string>;
  queryManagementGroup?: Array<string>;
  queryPositionClass?: Array<string>;
  queryMercerJobCode?: Array<string>;
  queryOrgCluster?: Array<string>;
  queryOrgClusterNode?: Array<string>;
  queryGeoCluster?: Array<string>;
  queryGeoClusterNode?: Array<string>;
  queryCountry?: Array<string>;
  queryGid?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryContractStatus?: Array<string>;
  queryAre?: Array<string>;
  queryWorkflow?: Array<string>;
  queryIsFlagged?: boolean;
  queryIsMeritExcluded?: boolean;
  queryIsIncentiveExcluded?: boolean;
  queryIsEquityExcluded?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  impersonatedEmployee?: string;
}

export interface RecalculateAllocationWorkflowsParams {
  recalculateAllocationWorkflow?: RecalculateAllocationWorkflow;
}

export interface RefineMeritTasksSeasonsParams {
  seasonId: string;
}

export interface ResetEmployeePromotionAllocationMembersParams {
  seasonId: string;
  employeeId: string;
}

export interface SetMeritSeasonToPayrollAndLetterStateSeasonsParams {
  seasonId: string;
}

export interface SetWasPromotedAllocationMembersParams {
  seasonId: string;
  employeeId: string;
  setWasPromotedForAllocationMember?: SetWasPromotedForAllocationMember;
}

export interface SimulateRuleAllocationWorkflowsParams {
  id: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SimulateRuleIndividualMultiplierSettingsParams {
  id: string;
  simulationId: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface StartCalculationSingleCalculationParams {
  seasonId: string;
  simulationId: string;
  meritSingleCalculationCommand?: MeritSingleCalculationCommand;
}

export interface TransferCompensationOverlaysSeasonsParams {
  seasonId: string;
}

export interface TransferMercerDataSeasonsParams {
  seasonId: string;
}

export interface TriggerNewHireProcessAllocationsParams {
  triggerNewHireProcess?: TriggerNewHireProcess;
}

export interface UpdateAllocationSettingsAllocationSettingsParams {
  seasonId: string;
  updateAllocationSettings?: UpdateAllocationSettings;
}

export interface UpdateAllocationWorkflowsParams {
  id: string;
  updateAllocationWorkflow?: UpdateAllocationWorkflow;
}

export interface UpdateEquitySettingsParams {
  simulationId: string;
  id: string;
  updateEquitySettings?: UpdateEquitySettings;
}

export interface UpdateEquitySubSettingsParams {
  id: string;
  simulationId: string;
  updateEquitySubSettings?: UpdateEquitySubSettings;
}

export interface UpdateEquityTypeEquitySubSettingsParams {
  id: string;
  simulationId: string;
  updateEquitySubSettingsEquityType?: UpdateEquitySubSettingsEquityType;
}

export interface UpdateIndividualMultiplierSettingsParams {
  simulationId2: string;
  simulationId?: string;
  updateIndividualMultiplierSettings?: UpdateIndividualMultiplierSettings;
}

export interface UpdateMeritIncentiveSettingsParams {
  simulationId: string;
  id: string;
  updateMeritIncentiveSettings?: UpdateMeritIncentiveSettings;
}

export interface UpdateMeritIncentiveSubSettingsParams {
  id: string;
  simulationId: string;
  updateMeritIncentiveSubSettings?: UpdateMeritIncentiveSubSettings;
}

export interface UpdatePromotionDateSettingPromotionSettingParams {
  seasonId: string;
  setPromotionDateSettingsCommand?: SetPromotionDateSettingsCommand;
}

@Injectable({
  providedIn: 'root'
})
export class MeritAdminService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public approveEmployeeAllocationMembers(
    requestParameters?: ApproveEmployeeAllocationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public approveEmployeeAllocationMembers(
    requestParameters?: ApproveEmployeeAllocationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public approveEmployeeAllocationMembers(
    requestParameters?: ApproveEmployeeAllocationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public approveEmployeeAllocationMembers(
    requestParameters?: ApproveEmployeeAllocationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('approveEmployeeAllocationMembers', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approve`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public autoFinalizeAllocationsAllocations(
    requestParameters?: AutoFinalizeAllocationsAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfIMetadata>;
  public autoFinalizeAllocationsAllocations(
    requestParameters?: AutoFinalizeAllocationsAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public autoFinalizeAllocationsAllocations(
    requestParameters?: AutoFinalizeAllocationsAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public autoFinalizeAllocationsAllocations(
    requestParameters?: AutoFinalizeAllocationsAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('autoFinalizeAllocationsAllocations', { seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/auto-finalize`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerGid: requestParameters?.lineManagerGid,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        State: requestParameters?.state,
        TemplateName: requestParameters?.templateName,
        TemplateType: requestParameters?.templateType,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        ExportedAt: requestParameters?.exportedAt,
        ExportedAtMax: requestParameters?.exportedAtMax,
        IsOtpOnly: requestParameters?.isOtpOnly,
        HasPreset: requestParameters?.hasPreset
      },
      body: requestParameters?.autoFinalize,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changeAllocationManagerAllocationMembers(
    requestParameters?: ChangeAllocationManagerAllocationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public changeAllocationManagerAllocationMembers(
    requestParameters?: ChangeAllocationManagerAllocationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public changeAllocationManagerAllocationMembers(
    requestParameters?: ChangeAllocationManagerAllocationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public changeAllocationManagerAllocationMembers(
    requestParameters?: ChangeAllocationManagerAllocationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('changeAllocationManagerAllocationMembers', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/change-allocation-manager`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.changeAllocationManager,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesAllocationWorkflows(
    requestParameters?: ChangePrioritiesAllocationWorkflowsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public changePrioritiesAllocationWorkflows(
    requestParameters?: ChangePrioritiesAllocationWorkflowsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public changePrioritiesAllocationWorkflows(
    requestParameters?: ChangePrioritiesAllocationWorkflowsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public changePrioritiesAllocationWorkflows(
    requestParameters?: ChangePrioritiesAllocationWorkflowsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/allocations/workflows/priorities`,
      accepts: [],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesEquitySettings(
    requestParameters?: ChangePrioritiesEquitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public changePrioritiesEquitySettings(
    requestParameters?: ChangePrioritiesEquitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public changePrioritiesEquitySettings(
    requestParameters?: ChangePrioritiesEquitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public changePrioritiesEquitySettings(
    requestParameters?: ChangePrioritiesEquitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('changePrioritiesEquitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/equity/priorities`,
      accepts: [],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesEquitySubSettings(
    requestParameters?: ChangePrioritiesEquitySubSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public changePrioritiesEquitySubSettings(
    requestParameters?: ChangePrioritiesEquitySubSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public changePrioritiesEquitySubSettings(
    requestParameters?: ChangePrioritiesEquitySubSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public changePrioritiesEquitySubSettings(
    requestParameters?: ChangePrioritiesEquitySubSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('changePrioritiesEquitySubSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/equity/sub-settings/priorities`,
      accepts: [],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesIndividualMultiplierSettings(
    requestParameters?: ChangePrioritiesIndividualMultiplierSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public changePrioritiesIndividualMultiplierSettings(
    requestParameters?: ChangePrioritiesIndividualMultiplierSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public changePrioritiesIndividualMultiplierSettings(
    requestParameters?: ChangePrioritiesIndividualMultiplierSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public changePrioritiesIndividualMultiplierSettings(
    requestParameters?: ChangePrioritiesIndividualMultiplierSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('changePrioritiesIndividualMultiplierSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/individual-multiplier/priorities`,
      accepts: [],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesMeritIncentiveSettings(
    requestParameters?: ChangePrioritiesMeritIncentiveSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public changePrioritiesMeritIncentiveSettings(
    requestParameters?: ChangePrioritiesMeritIncentiveSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public changePrioritiesMeritIncentiveSettings(
    requestParameters?: ChangePrioritiesMeritIncentiveSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public changePrioritiesMeritIncentiveSettings(
    requestParameters?: ChangePrioritiesMeritIncentiveSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('changePrioritiesMeritIncentiveSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/incentive/priorities`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesMeritIncentiveSubSettings(
    requestParameters?: ChangePrioritiesMeritIncentiveSubSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public changePrioritiesMeritIncentiveSubSettings(
    requestParameters?: ChangePrioritiesMeritIncentiveSubSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public changePrioritiesMeritIncentiveSubSettings(
    requestParameters?: ChangePrioritiesMeritIncentiveSubSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public changePrioritiesMeritIncentiveSubSettings(
    requestParameters?: ChangePrioritiesMeritIncentiveSubSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('changePrioritiesMeritIncentiveSubSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/incentive/sub-settings/priorities`,
      accepts: [],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesSettings(
    requestParameters?: ChangePrioritiesSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public changePrioritiesSettings(
    requestParameters?: ChangePrioritiesSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public changePrioritiesSettings(
    requestParameters?: ChangePrioritiesSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public changePrioritiesSettings(
    requestParameters?: ChangePrioritiesSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('changePrioritiesSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/merit/priorities`,
      accepts: [],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createAllocationMemberComments(
    requestParameters?: CreateAllocationMemberCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<AllocationComment>;
  public createAllocationMemberComments(
    requestParameters?: CreateAllocationMemberCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<AllocationComment>>;
  public createAllocationMemberComments(
    requestParameters?: CreateAllocationMemberCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<AllocationComment>>;
  public createAllocationMemberComments(
    requestParameters?: CreateAllocationMemberCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('createAllocationMemberComments', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/values/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createAllocationComment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createAllocationSettingsAllocationSettings(
    requestParameters?: CreateAllocationSettingsAllocationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<AllocationSettings>;
  public createAllocationSettingsAllocationSettings(
    requestParameters?: CreateAllocationSettingsAllocationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<AllocationSettings>>;
  public createAllocationSettingsAllocationSettings(
    requestParameters?: CreateAllocationSettingsAllocationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<AllocationSettings>>;
  public createAllocationSettingsAllocationSettings(
    requestParameters?: CreateAllocationSettingsAllocationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('createAllocationSettingsAllocationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/merit-allocation-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createAllocationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createAllocationWorkflows(
    requestParameters?: CreateAllocationWorkflowsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<AllocationWorkflow>;
  public createAllocationWorkflows(
    requestParameters?: CreateAllocationWorkflowsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<AllocationWorkflow>>;
  public createAllocationWorkflows(
    requestParameters?: CreateAllocationWorkflowsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<AllocationWorkflow>>;
  public createAllocationWorkflows(
    requestParameters?: CreateAllocationWorkflowsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/allocations/workflows`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createAllocationWorkflow,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createEquitySettings(
    requestParameters?: CreateEquitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EquitySettingsModel>;
  public createEquitySettings(
    requestParameters?: CreateEquitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EquitySettingsModel>>;
  public createEquitySettings(
    requestParameters?: CreateEquitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EquitySettingsModel>>;
  public createEquitySettings(requestParameters?: CreateEquitySettingsParams, ...args: RequestArgs): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('createEquitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/equity`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createEquitySettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createEquitySubSettings(
    requestParameters?: CreateEquitySubSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EquitySubSettingsModel>;
  public createEquitySubSettings(
    requestParameters?: CreateEquitySubSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EquitySubSettingsModel>>;
  public createEquitySubSettings(
    requestParameters?: CreateEquitySubSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EquitySubSettingsModel>>;
  public createEquitySubSettings(
    requestParameters?: CreateEquitySubSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('createEquitySubSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/equity/sub-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createEquitySubSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createIndividualMultiplierSettings(
    requestParameters?: CreateIndividualMultiplierSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IndividualMultiplierSettingsModel>;
  public createIndividualMultiplierSettings(
    requestParameters?: CreateIndividualMultiplierSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IndividualMultiplierSettingsModel>>;
  public createIndividualMultiplierSettings(
    requestParameters?: CreateIndividualMultiplierSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IndividualMultiplierSettingsModel>>;
  public createIndividualMultiplierSettings(
    requestParameters?: CreateIndividualMultiplierSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('createIndividualMultiplierSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/individual-multiplier`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createIndividualMultiplierSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMeritIncentiveSettings(
    requestParameters?: CreateMeritIncentiveSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritIncentiveSettingsModel>;
  public createMeritIncentiveSettings(
    requestParameters?: CreateMeritIncentiveSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritIncentiveSettingsModel>>;
  public createMeritIncentiveSettings(
    requestParameters?: CreateMeritIncentiveSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritIncentiveSettingsModel>>;
  public createMeritIncentiveSettings(
    requestParameters?: CreateMeritIncentiveSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('createMeritIncentiveSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/incentive`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMeritIncentiveSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMeritIncentiveSubSettings(
    requestParameters?: CreateMeritIncentiveSubSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritIncentiveSubSettingsModel>;
  public createMeritIncentiveSubSettings(
    requestParameters?: CreateMeritIncentiveSubSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritIncentiveSubSettingsModel>>;
  public createMeritIncentiveSubSettings(
    requestParameters?: CreateMeritIncentiveSubSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritIncentiveSubSettingsModel>>;
  public createMeritIncentiveSubSettings(
    requestParameters?: CreateMeritIncentiveSubSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('createMeritIncentiveSubSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/incentive/sub-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMeritIncentiveSubSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a zip containing all Merit Letters matching the filter query
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMeritLetterZipMeritLetterZip(
    requestParameters?: CreateMeritLetterZipMeritLetterZipParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<string>;
  public createMeritLetterZipMeritLetterZip(
    requestParameters?: CreateMeritLetterZipMeritLetterZipParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<string>>;
  public createMeritLetterZipMeritLetterZip(
    requestParameters?: CreateMeritLetterZipMeritLetterZipParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<string>>;
  public createMeritLetterZipMeritLetterZip(
    requestParameters?: CreateMeritLetterZipMeritLetterZipParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('createMeritLetterZipMeritLetterZip', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/create-zip`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Id': requestParameters?.queryId,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanName': requestParameters?.queryPlanName,
        'Query.State': requestParameters?.queryState,
        'Query.StartDate': requestParameters?.queryStartDate,
        'Query.EndDate': requestParameters?.queryEndDate,
        'Query.PayoutDate': requestParameters?.queryPayoutDate,
        'Query.AssignmentManager': requestParameters?.queryAssignmentManager,
        'Query.AssignmentId': requestParameters?.queryAssignmentId,
        'Query.LetterType': requestParameters?.queryLetterType,
        'Query.ProcessStates': requestParameters?.queryProcessStates,
        'Query.RecordCommunicationStates': requestParameters?.queryRecordCommunicationStates,
        'Query.Workflow': requestParameters?.queryWorkflow,
        'Query.Template': requestParameters?.queryTemplate,
        'Query.IsDesignReady': requestParameters?.queryIsDesignReady,
        'Query.PayoutState': requestParameters?.queryPayoutState,
        'Query.ManagerSetMercerJobCode': requestParameters?.queryManagerSetMercerJobCode,
        'Query.EditedMercerJobCode': requestParameters?.queryEditedMercerJobCode,
        'Query.CurrentMercerJobCode': requestParameters?.queryCurrentMercerJobCode,
        'Query.IsMercerJobCodeValid': requestParameters?.queryIsMercerJobCodeValid,
        'Query.IsGripCodeValid': requestParameters?.queryIsGripCodeValid,
        'Query.LineManagerName': requestParameters?.queryLineManagerName,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.WorkflowInstanceState': requestParameters?.queryWorkflowInstanceState,
        'Query.Multiplier': requestParameters?.queryMultiplier,
        'Query.OverallTargetAchievement': requestParameters?.queryOverallTargetAchievement,
        'Query.PayoutAmount': requestParameters?.queryPayoutAmount,
        'Query.PayoutCurrency': requestParameters?.queryPayoutCurrency,
        'Query.IppAchievementValue': requestParameters?.queryIppAchievementValue,
        'Query.IncentivePaymentType': requestParameters?.queryIncentivePaymentType,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPromotionDateSettingPromotionSetting(
    requestParameters?: CreatePromotionDateSettingPromotionSettingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritPromotionDateSettingModel>;
  public createPromotionDateSettingPromotionSetting(
    requestParameters?: CreatePromotionDateSettingPromotionSettingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritPromotionDateSettingModel>>;
  public createPromotionDateSettingPromotionSetting(
    requestParameters?: CreatePromotionDateSettingPromotionSettingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritPromotionDateSettingModel>>;
  public createPromotionDateSettingPromotionSetting(
    requestParameters?: CreatePromotionDateSettingPromotionSettingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('createPromotionDateSettingPromotionSetting', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/promotion-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.setPromotionDateSettingsCommand,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteOrganisationUploads(
    requestParameters?: DeleteOrganisationUploadsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteOrganisationUploads(
    requestParameters?: DeleteOrganisationUploadsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteOrganisationUploads(
    requestParameters?: DeleteOrganisationUploadsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteOrganisationUploads(
    requestParameters?: DeleteOrganisationUploadsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('deleteOrganisationUploads', { seasonId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisation-uploads`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public disableEmployeeAllocationMembers(
    requestParameters?: DisableEmployeeAllocationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public disableEmployeeAllocationMembers(
    requestParameters?: DisableEmployeeAllocationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public disableEmployeeAllocationMembers(
    requestParameters?: DisableEmployeeAllocationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public disableEmployeeAllocationMembers(
    requestParameters?: DisableEmployeeAllocationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('disableEmployeeAllocationMembers', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/disable`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public editAllocatedMemberRecords(
    requestParameters?: EditAllocatedMemberRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public editAllocatedMemberRecords(
    requestParameters?: EditAllocatedMemberRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public editAllocatedMemberRecords(
    requestParameters?: EditAllocatedMemberRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public editAllocatedMemberRecords(
    requestParameters?: EditAllocatedMemberRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('editAllocatedMemberRecords', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/member`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.editAllocatedMember,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeeAssignmentsSeasons(
    requestParameters?: ExportEmployeeAssignmentsSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeeAssignmentsSeasons(
    requestParameters?: ExportEmployeeAssignmentsSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeAssignmentsSeasons(
    requestParameters?: ExportEmployeeAssignmentsSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeAssignmentsSeasons(
    requestParameters?: ExportEmployeeAssignmentsSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportEmployeeAssignmentsSeasons', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employee-assignments/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMeritExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportMeritEmployeeDataSeasons(
    requestParameters?: ExportMeritEmployeeDataSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportMeritEmployeeDataSeasons(
    requestParameters?: ExportMeritEmployeeDataSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportMeritEmployeeDataSeasons(
    requestParameters?: ExportMeritEmployeeDataSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportMeritEmployeeDataSeasons(
    requestParameters?: ExportMeritEmployeeDataSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportMeritEmployeeDataSeasons', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employee-data/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMeritExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportMeritSimulationMemberTagsSimulationMembers(
    requestParameters?: ExportMeritSimulationMemberTagsSimulationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportMeritSimulationMemberTagsSimulationMembers(
    requestParameters?: ExportMeritSimulationMemberTagsSimulationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportMeritSimulationMemberTagsSimulationMembers(
    requestParameters?: ExportMeritSimulationMemberTagsSimulationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportMeritSimulationMemberTagsSimulationMembers(
    requestParameters?: ExportMeritSimulationMemberTagsSimulationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('exportMeritSimulationMemberTagsSimulationMembers', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/members/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/tags/export`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportMidYearIncreaseSimulationMembers(
    requestParameters?: ExportMidYearIncreaseSimulationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportMidYearIncreaseSimulationMembers(
    requestParameters?: ExportMidYearIncreaseSimulationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportMidYearIncreaseSimulationMembers(
    requestParameters?: ExportMidYearIncreaseSimulationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportMidYearIncreaseSimulationMembers(
    requestParameters?: ExportMidYearIncreaseSimulationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('exportMidYearIncreaseSimulationMembers', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/members/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/mid-year-increase/export`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportMultiplierDifferentiationDataSeasons(
    requestParameters?: ExportMultiplierDifferentiationDataSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportMultiplierDifferentiationDataSeasons(
    requestParameters?: ExportMultiplierDifferentiationDataSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportMultiplierDifferentiationDataSeasons(
    requestParameters?: ExportMultiplierDifferentiationDataSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportMultiplierDifferentiationDataSeasons(
    requestParameters?: ExportMultiplierDifferentiationDataSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportMultiplierDifferentiationDataSeasons', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/multiplier-differentiation-data/export`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportOrganisationUploads(
    requestParameters?: ExportOrganisationUploadsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportOrganisationUploads(
    requestParameters?: ExportOrganisationUploadsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportOrganisationUploads(
    requestParameters?: ExportOrganisationUploadsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportOrganisationUploads(
    requestParameters?: ExportOrganisationUploadsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportOrganisationUploads', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisation-uploads/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { fileName: requestParameters?.fileName }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportPayGapCountryDataSeasons(
    requestParameters?: ExportPayGapCountryDataSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportPayGapCountryDataSeasons(
    requestParameters?: ExportPayGapCountryDataSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportPayGapCountryDataSeasons(
    requestParameters?: ExportPayGapCountryDataSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportPayGapCountryDataSeasons(
    requestParameters?: ExportPayGapCountryDataSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportPayGapCountryDataSeasons', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/country-pay-gap-data/export`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportPayGapEmployeeDataSeasons(
    requestParameters?: ExportPayGapEmployeeDataSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportPayGapEmployeeDataSeasons(
    requestParameters?: ExportPayGapEmployeeDataSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportPayGapEmployeeDataSeasons(
    requestParameters?: ExportPayGapEmployeeDataSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportPayGapEmployeeDataSeasons(
    requestParameters?: ExportPayGapEmployeeDataSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportPayGapEmployeeDataSeasons', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employee-pay-gap-data/export`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public flagEmployeeAllocationMembers(
    requestParameters?: FlagEmployeeAllocationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public flagEmployeeAllocationMembers(
    requestParameters?: FlagEmployeeAllocationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public flagEmployeeAllocationMembers(
    requestParameters?: FlagEmployeeAllocationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public flagEmployeeAllocationMembers(
    requestParameters?: FlagEmployeeAllocationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const allocationMemberId = requestParameters?.allocationMemberId;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('flagEmployeeAllocationMembers', { allocationMemberId, seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/allocations/${this.configuration.encodeParam({ name: 'allocationMemberId', value: allocationMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/flag`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.setFlagForAllocationMember,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllocationMemberRecords(
    requestParameters?: GetAllocationMemberRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public getAllocationMemberRecords(
    requestParameters?: GetAllocationMemberRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public getAllocationMemberRecords(
    requestParameters?: GetAllocationMemberRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public getAllocationMemberRecords(
    requestParameters?: GetAllocationMemberRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getAllocationMemberRecords', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/member`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllocationSettingsForSeasonAllocationSettings(
    requestParameters?: GetAllocationSettingsForSeasonAllocationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<AllocationSettings>;
  public getAllocationSettingsForSeasonAllocationSettings(
    requestParameters?: GetAllocationSettingsForSeasonAllocationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<AllocationSettings>>;
  public getAllocationSettingsForSeasonAllocationSettings(
    requestParameters?: GetAllocationSettingsForSeasonAllocationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<AllocationSettings>>;
  public getAllocationSettingsForSeasonAllocationSettings(
    requestParameters?: GetAllocationSettingsForSeasonAllocationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getAllocationSettingsForSeasonAllocationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/merit-allocation-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllocationTotals(
    requestParameters?: GetAllocationTotalsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public getAllocationTotals(
    requestParameters?: GetAllocationTotalsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public getAllocationTotals(
    requestParameters?: GetAllocationTotalsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public getAllocationTotals(requestParameters?: GetAllocationTotalsParams, ...args: RequestArgs): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getAllocationTotals', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/total/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { impersonatedEmployee: requestParameters?.impersonatedEmployee, orgCode: requestParameters?.orgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdAllocationSettings(
    requestParameters?: GetByIdAllocationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<AllocationSettings>;
  public getByIdAllocationSettings(
    requestParameters?: GetByIdAllocationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<AllocationSettings>>;
  public getByIdAllocationSettings(
    requestParameters?: GetByIdAllocationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<AllocationSettings>>;
  public getByIdAllocationSettings(
    requestParameters?: GetByIdAllocationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getByIdAllocationSettings', { id, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/merit-allocation-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDirectsAllocationDirects(
    requestParameters?: GetDirectsAllocationDirectsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMeritAllocationMember>;
  public getDirectsAllocationDirects(
    requestParameters?: GetDirectsAllocationDirectsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMeritAllocationMember>>;
  public getDirectsAllocationDirects(
    requestParameters?: GetDirectsAllocationDirectsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMeritAllocationMember>>;
  public getDirectsAllocationDirects(
    requestParameters?: GetDirectsAllocationDirectsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getDirectsAllocationDirects', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/directs`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        impersonatedEmployee: requestParameters?.impersonatedEmployee,
        Employees: requestParameters?.employees,
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.TargetTypeString': requestParameters?.queryTargetTypeString,
        'Query.MeritPopulation': requestParameters?.queryMeritPopulation,
        'Query.EquityPopulation': requestParameters?.queryEquityPopulation,
        'Query.ManagementGroup': requestParameters?.queryManagementGroup,
        'Query.PositionClass': requestParameters?.queryPositionClass,
        'Query.MercerJobCode': requestParameters?.queryMercerJobCode,
        'Query.OrgCluster': requestParameters?.queryOrgCluster,
        'Query.OrgClusterNode': requestParameters?.queryOrgClusterNode,
        'Query.GeoCluster': requestParameters?.queryGeoCluster,
        'Query.GeoClusterNode': requestParameters?.queryGeoClusterNode,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Gid': requestParameters?.queryGid,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.Are': requestParameters?.queryAre,
        'Query.Workflow': requestParameters?.queryWorkflow,
        'Query.IsFlagged': requestParameters?.queryIsFlagged,
        'Query.IsMeritExcluded': requestParameters?.queryIsMeritExcluded,
        'Query.IsIncentiveExcluded': requestParameters?.queryIsIncentiveExcluded,
        'Query.IsEquityExcluded': requestParameters?.queryIsEquityExcluded,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDirectsFieldValuesAllocationDirects(
    requestParameters?: GetDirectsFieldValuesAllocationDirectsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getDirectsFieldValuesAllocationDirects(
    requestParameters?: GetDirectsFieldValuesAllocationDirectsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getDirectsFieldValuesAllocationDirects(
    requestParameters?: GetDirectsFieldValuesAllocationDirectsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getDirectsFieldValuesAllocationDirects(
    requestParameters?: GetDirectsFieldValuesAllocationDirectsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getDirectsFieldValuesAllocationDirects', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/directs/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        IsMeritExcluded: requestParameters?.isMeritExcluded,
        IsEquityExcluded: requestParameters?.isEquityExcluded,
        Promotion: requestParameters?.promotion,
        NewHire: requestParameters?.newHire,
        ManuallyChanged: requestParameters?.manuallyChanged,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        EquityPopulation: requestParameters?.equityPopulation,
        MeritPopulation: requestParameters?.meritPopulation,
        Workflow: requestParameters?.workflow,
        Are: requestParameters?.are,
        ContractStatus: requestParameters?.contractStatus,
        Country: requestParameters?.country,
        CountryInverted: requestParameters?.countryInverted,
        GeoCluster: requestParameters?.geoCluster,
        GeoClusterNode: requestParameters?.geoClusterNode,
        ManagementGroup: requestParameters?.managementGroup,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        PAOrgCode: requestParameters?.pAOrgCode,
        MercerJobCode: requestParameters?.mercerJobCode,
        OrgCluster: requestParameters?.orgCluster,
        OrgClusterNode: requestParameters?.orgClusterNode,
        PositionClass: requestParameters?.positionClass,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        IndividualMultiplier: requestParameters?.individualMultiplier,
        IndividualAllocationValueIsDone: requestParameters?.individualAllocationValueIsDone,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        impersonatedEmployee: requestParameters?.impersonatedEmployee
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDirectsOverviewAllocationDirects(
    requestParameters?: GetDirectsOverviewAllocationDirectsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationOverview>;
  public getDirectsOverviewAllocationDirects(
    requestParameters?: GetDirectsOverviewAllocationDirectsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationOverview>>;
  public getDirectsOverviewAllocationDirects(
    requestParameters?: GetDirectsOverviewAllocationDirectsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationOverview>>;
  public getDirectsOverviewAllocationDirects(
    requestParameters?: GetDirectsOverviewAllocationDirectsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getDirectsOverviewAllocationDirects', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/directs/overview`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { impersonatedEmployee: requestParameters?.impersonatedEmployee }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDownloadBySettingSimulationMembers(
    requestParameters?: GetDownloadBySettingSimulationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<IndividualMeritValueDownload>>;
  public getDownloadBySettingSimulationMembers(
    requestParameters?: GetDownloadBySettingSimulationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<IndividualMeritValueDownload>>>;
  public getDownloadBySettingSimulationMembers(
    requestParameters?: GetDownloadBySettingSimulationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<IndividualMeritValueDownload>>>;
  public getDownloadBySettingSimulationMembers(
    requestParameters?: GetDownloadBySettingSimulationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const meritSettingsId = requestParameters?.meritSettingsId;
    this.checkRequired('getDownloadBySettingSimulationMembers', { meritSettingsId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/members/individual-merit-values/${this.configuration.encodeParam({ name: 'meritSettingsId', value: meritSettingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeePromotionAllocationMembers(
    requestParameters?: GetEmployeePromotionAllocationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritEmployeePromotion>;
  public getEmployeePromotionAllocationMembers(
    requestParameters?: GetEmployeePromotionAllocationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritEmployeePromotion>>;
  public getEmployeePromotionAllocationMembers(
    requestParameters?: GetEmployeePromotionAllocationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritEmployeePromotion>>;
  public getEmployeePromotionAllocationMembers(
    requestParameters?: GetEmployeePromotionAllocationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getEmployeePromotionAllocationMembers', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/promotion`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getInfoOrganisationUploads(
    requestParameters?: GetInfoOrganisationUploadsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritOrganisationUploadInfo>;
  public getInfoOrganisationUploads(
    requestParameters?: GetInfoOrganisationUploadsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritOrganisationUploadInfo>>;
  public getInfoOrganisationUploads(
    requestParameters?: GetInfoOrganisationUploadsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritOrganisationUploadInfo>>;
  public getInfoOrganisationUploads(
    requestParameters?: GetInfoOrganisationUploadsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getInfoOrganisationUploads', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisation-uploads`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPayrollExportByListRecords(
    requestParameters?: GetPayrollExportByListRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public getPayrollExportByListRecords(
    requestParameters?: GetPayrollExportByListRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public getPayrollExportByListRecords(
    requestParameters?: GetPayrollExportByListRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public getPayrollExportByListRecords(
    requestParameters?: GetPayrollExportByListRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getPayrollExportByListRecords', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerGid: requestParameters?.lineManagerGid,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        State: requestParameters?.state,
        TemplateName: requestParameters?.templateName,
        TemplateType: requestParameters?.templateType,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        ExportedAt: requestParameters?.exportedAt,
        ExportedAtMax: requestParameters?.exportedAtMax,
        IsOtpOnly: requestParameters?.isOtpOnly,
        HasPreset: requestParameters?.hasPreset
      },
      body: requestParameters?.createMeritPayrollExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPromotionBudgetsAllocationPromotionBudgets(
    requestParameters?: GetPromotionBudgetsAllocationPromotionBudgetsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PromotionBudgetResult>;
  public getPromotionBudgetsAllocationPromotionBudgets(
    requestParameters?: GetPromotionBudgetsAllocationPromotionBudgetsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PromotionBudgetResult>>;
  public getPromotionBudgetsAllocationPromotionBudgets(
    requestParameters?: GetPromotionBudgetsAllocationPromotionBudgetsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PromotionBudgetResult>>;
  public getPromotionBudgetsAllocationPromotionBudgets(
    requestParameters?: GetPromotionBudgetsAllocationPromotionBudgetsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getPromotionBudgetsAllocationPromotionBudgets', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/promotions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { impersonatedEmployee: requestParameters?.impersonatedEmployee, OrgCode: requestParameters?.orgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPromotionDateSettingPromotionSetting(
    requestParameters?: GetPromotionDateSettingPromotionSettingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritPromotionDateSettingModel>;
  public getPromotionDateSettingPromotionSetting(
    requestParameters?: GetPromotionDateSettingPromotionSettingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritPromotionDateSettingModel>>;
  public getPromotionDateSettingPromotionSetting(
    requestParameters?: GetPromotionDateSettingPromotionSettingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritPromotionDateSettingModel>>;
  public getPromotionDateSettingPromotionSetting(
    requestParameters?: GetPromotionDateSettingPromotionSettingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getPromotionDateSettingPromotionSetting', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/promotion-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPromotionsOverviewAllocationPromotionBudgets(
    requestParameters?: GetPromotionsOverviewAllocationPromotionBudgetsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PromotionBudgetOverview>;
  public getPromotionsOverviewAllocationPromotionBudgets(
    requestParameters?: GetPromotionsOverviewAllocationPromotionBudgetsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PromotionBudgetOverview>>;
  public getPromotionsOverviewAllocationPromotionBudgets(
    requestParameters?: GetPromotionsOverviewAllocationPromotionBudgetsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PromotionBudgetOverview>>;
  public getPromotionsOverviewAllocationPromotionBudgets(
    requestParameters?: GetPromotionsOverviewAllocationPromotionBudgetsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getPromotionsOverviewAllocationPromotionBudgets', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/promotions/overview`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { impersonatedEmployee: requestParameters?.impersonatedEmployee, OrgCode: requestParameters?.orgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getResponsiblePromotionApproverAllocationMembers(
    requestParameters?: GetResponsiblePromotionApproverAllocationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritResponsiblePromotionApprover>;
  public getResponsiblePromotionApproverAllocationMembers(
    requestParameters?: GetResponsiblePromotionApproverAllocationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritResponsiblePromotionApprover>>;
  public getResponsiblePromotionApproverAllocationMembers(
    requestParameters?: GetResponsiblePromotionApproverAllocationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritResponsiblePromotionApprover>>;
  public getResponsiblePromotionApproverAllocationMembers(
    requestParameters?: GetResponsiblePromotionApproverAllocationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getResponsiblePromotionApproverAllocationMembers', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/promotion-approver`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasonsForAllocationAllocations(
    requestParameters?: GetSeasonsForAllocationAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfAllocationSeason>;
  public getSeasonsForAllocationAllocations(
    requestParameters?: GetSeasonsForAllocationAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfAllocationSeason>>;
  public getSeasonsForAllocationAllocations(
    requestParameters?: GetSeasonsForAllocationAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfAllocationSeason>>;
  public getSeasonsForAllocationAllocations(
    requestParameters?: GetSeasonsForAllocationAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/allocations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTaskForSimulationMemberAllocationMembers(
    requestParameters?: GetTaskForSimulationMemberAllocationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<string>;
  public getTaskForSimulationMemberAllocationMembers(
    requestParameters?: GetTaskForSimulationMemberAllocationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<string>>;
  public getTaskForSimulationMemberAllocationMembers(
    requestParameters?: GetTaskForSimulationMemberAllocationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<string>>;
  public getTaskForSimulationMemberAllocationMembers(
    requestParameters?: GetTaskForSimulationMemberAllocationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getTaskForSimulationMemberAllocationMembers', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/due-date`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTasksTotalOverviewAllocationTotals(
    requestParameters?: GetTasksTotalOverviewAllocationTotalsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationOverview>;
  public getTasksTotalOverviewAllocationTotals(
    requestParameters?: GetTasksTotalOverviewAllocationTotalsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationOverview>>;
  public getTasksTotalOverviewAllocationTotals(
    requestParameters?: GetTasksTotalOverviewAllocationTotalsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationOverview>>;
  public getTasksTotalOverviewAllocationTotals(
    requestParameters?: GetTasksTotalOverviewAllocationTotalsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getTasksTotalOverviewAllocationTotals', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/tasks/overview/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { OrgCode: requestParameters?.orgCode, impersonatedEmployee: requestParameters?.impersonatedEmployee }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTotalOverviewAllocationTotals(
    requestParameters?: GetTotalOverviewAllocationTotalsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationOverview>;
  public getTotalOverviewAllocationTotals(
    requestParameters?: GetTotalOverviewAllocationTotalsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationOverview>>;
  public getTotalOverviewAllocationTotals(
    requestParameters?: GetTotalOverviewAllocationTotalsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationOverview>>;
  public getTotalOverviewAllocationTotals(
    requestParameters?: GetTotalOverviewAllocationTotalsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getTotalOverviewAllocationTotals', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/total/overview/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { impersonatedEmployee: requestParameters?.impersonatedEmployee, OrgCode: requestParameters?.orgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTotalsFieldValuesAllocationTotals(
    requestParameters?: GetTotalsFieldValuesAllocationTotalsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getTotalsFieldValuesAllocationTotals(
    requestParameters?: GetTotalsFieldValuesAllocationTotalsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getTotalsFieldValuesAllocationTotals(
    requestParameters?: GetTotalsFieldValuesAllocationTotalsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getTotalsFieldValuesAllocationTotals(
    requestParameters?: GetTotalsFieldValuesAllocationTotalsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getTotalsFieldValuesAllocationTotals', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/totals/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        parentOrgCode: requestParameters?.parentOrgCode,
        TargetProperty: requestParameters?.targetProperty,
        IsMeritExcluded: requestParameters?.isMeritExcluded,
        IsEquityExcluded: requestParameters?.isEquityExcluded,
        Promotion: requestParameters?.promotion,
        NewHire: requestParameters?.newHire,
        ManuallyChanged: requestParameters?.manuallyChanged,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        EquityPopulation: requestParameters?.equityPopulation,
        MeritPopulation: requestParameters?.meritPopulation,
        Workflow: requestParameters?.workflow,
        Are: requestParameters?.are,
        ContractStatus: requestParameters?.contractStatus,
        Country: requestParameters?.country,
        CountryInverted: requestParameters?.countryInverted,
        GeoCluster: requestParameters?.geoCluster,
        GeoClusterNode: requestParameters?.geoClusterNode,
        ManagementGroup: requestParameters?.managementGroup,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        PAOrgCode: requestParameters?.pAOrgCode,
        MercerJobCode: requestParameters?.mercerJobCode,
        OrgCluster: requestParameters?.orgCluster,
        OrgClusterNode: requestParameters?.orgClusterNode,
        PositionClass: requestParameters?.positionClass,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        IndividualMultiplier: requestParameters?.individualMultiplier,
        IndividualAllocationValueIsDone: requestParameters?.individualAllocationValueIsDone,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        impersonatedEmployee: requestParameters?.impersonatedEmployee
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public historizeHistorization(
    requestParameters?: HistorizeHistorizationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfMeritResultsHistoryMetadata>;
  public historizeHistorization(
    requestParameters?: HistorizeHistorizationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfMeritResultsHistoryMetadata>>;
  public historizeHistorization(
    requestParameters?: HistorizeHistorizationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfMeritResultsHistoryMetadata>>;
  public historizeHistorization(
    requestParameters?: HistorizeHistorizationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('historizeHistorization', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/history`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerGid: requestParameters?.lineManagerGid,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        State: requestParameters?.state,
        TemplateName: requestParameters?.templateName,
        TemplateType: requestParameters?.templateType,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        ExportedAt: requestParameters?.exportedAt,
        ExportedAtMax: requestParameters?.exportedAtMax,
        IsOtpOnly: requestParameters?.isOtpOnly,
        HasPreset: requestParameters?.hasPreset
      },
      body: requestParameters?.createMeritHistoryResults,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritAdminCreateSettings(
    requestParameters?: MeritAdminCreateSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritSimulationSettings>;
  public meritAdminCreateSettings(
    requestParameters?: MeritAdminCreateSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritSimulationSettings>>;
  public meritAdminCreateSettings(
    requestParameters?: MeritAdminCreateSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritSimulationSettings>>;
  public meritAdminCreateSettings(
    requestParameters?: MeritAdminCreateSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('meritAdminCreateSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/merit`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMeritSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritAdminQueryFieldValuesRecords(
    requestParameters?: MeritAdminQueryFieldValuesRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public meritAdminQueryFieldValuesRecords(
    requestParameters?: MeritAdminQueryFieldValuesRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public meritAdminQueryFieldValuesRecords(
    requestParameters?: MeritAdminQueryFieldValuesRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public meritAdminQueryFieldValuesRecords(
    requestParameters?: MeritAdminQueryFieldValuesRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('meritAdminQueryFieldValuesRecords', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerGid: requestParameters?.lineManagerGid,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        State: requestParameters?.state,
        TemplateName: requestParameters?.templateName,
        TemplateType: requestParameters?.templateType,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        ExportedAt: requestParameters?.exportedAt,
        ExportedAtMax: requestParameters?.exportedAtMax,
        IsOtpOnly: requestParameters?.isOtpOnly,
        HasPreset: requestParameters?.hasPreset,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritAdminQueryFieldValuesSettings(
    requestParameters?: MeritAdminQueryFieldValuesSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public meritAdminQueryFieldValuesSettings(
    requestParameters?: MeritAdminQueryFieldValuesSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public meritAdminQueryFieldValuesSettings(
    requestParameters?: MeritAdminQueryFieldValuesSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public meritAdminQueryFieldValuesSettings(
    requestParameters?: MeritAdminQueryFieldValuesSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('meritAdminQueryFieldValuesSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/merit/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        TargetTypeString: requestParameters?.targetTypeString,
        SimulationId: requestParameters?.simulationId2,
        Priority: requestParameters?.priority,
        Title: requestParameters?.title,
        FixedAllocationPercentage: requestParameters?.fixedAllocationPercentage,
        FixedAllocationTotal: requestParameters?.fixedAllocationTotal,
        FixedAllocationCurrency: requestParameters?.fixedAllocationCurrency,
        FlexibleAllocationPercentage: requestParameters?.flexibleAllocationPercentage,
        MinimumIncreasePercentage: requestParameters?.minimumIncreasePercentage,
        MinimumIncreaseTotal: requestParameters?.minimumIncreaseTotal,
        MinimumIncreaseCurrency: requestParameters?.minimumIncreaseCurrency,
        UnrestrictedBudgetPercentage: requestParameters?.unrestrictedBudgetPercentage,
        EffectiveDateMeritAt: requestParameters?.effectiveDateMeritAt,
        EffectiveDateIncentiveAt: requestParameters?.effectiveDateIncentiveAt,
        EffectiveDateOTPAt: requestParameters?.effectiveDateOTPAt,
        IsPopulationExcluded: requestParameters?.isPopulationExcluded,
        AffectedCount: requestParameters?.affectedCount,
        Type: requestParameters?.type,
        AlreadyGrantedIncreaseCurrency: requestParameters?.alreadyGrantedIncreaseCurrency,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritAdminQueryRecords(
    requestParameters?: MeritAdminQueryRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMeritRecord>;
  public meritAdminQueryRecords(
    requestParameters?: MeritAdminQueryRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMeritRecord>>;
  public meritAdminQueryRecords(
    requestParameters?: MeritAdminQueryRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMeritRecord>>;
  public meritAdminQueryRecords(
    requestParameters?: MeritAdminQueryRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('meritAdminQueryRecords', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.MeritTitle': requestParameters?.queryMeritTitle,
        'Query.EquityTitle': requestParameters?.queryEquityTitle,
        'Query.EquitySubTitle': requestParameters?.queryEquitySubTitle,
        'Query.ManuallyChanged': requestParameters?.queryManuallyChanged,
        'Query.NewHire': requestParameters?.queryNewHire,
        'Query.Promotion': requestParameters?.queryPromotion,
        'Query.Termination': requestParameters?.queryTermination,
        'Query.PopulationChange': requestParameters?.queryPopulationChange,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.CompanyManagerGid': requestParameters?.queryCompanyManagerGid,
        'Query.LineManagerFirstName': requestParameters?.queryLineManagerFirstName,
        'Query.LineManagerLastName': requestParameters?.queryLineManagerLastName,
        'Query.CompanyManagerFirstName': requestParameters?.queryCompanyManagerFirstName,
        'Query.CompanyManagerLastName': requestParameters?.queryCompanyManagerLastName,
        'Query.State': requestParameters?.queryState,
        'Query.TemplateName': requestParameters?.queryTemplateName,
        'Query.TemplateType': requestParameters?.queryTemplateType,
        'Query.WorkflowType': requestParameters?.queryWorkflowType,
        'Query.AutoApprove': requestParameters?.queryAutoApprove,
        'Query.ApprovalRequired': requestParameters?.queryApprovalRequired,
        'Query.LetterState': requestParameters?.queryLetterState,
        'Query.ProcessState': requestParameters?.queryProcessState,
        'Query.ExportState': requestParameters?.queryExportState,
        'Query.PayrollState': requestParameters?.queryPayrollState,
        'Query.MeritRelevancy': requestParameters?.queryMeritRelevancy,
        'Query.EquityRelevancy': requestParameters?.queryEquityRelevancy,
        'Query.HasOtpIncrease': requestParameters?.queryHasOtpIncrease,
        'Query.ApprovedByCompanyManager': requestParameters?.queryApprovedByCompanyManager,
        'Query.AllocationWorkflowType': requestParameters?.queryAllocationWorkflowType,
        'Query.ReadyToPayroll': requestParameters?.queryReadyToPayroll,
        'Query.ExportedAt': requestParameters?.queryExportedAt,
        'Query.ExportedAtMax': requestParameters?.queryExportedAtMax,
        'Query.IsOtpOnly': requestParameters?.queryIsOtpOnly,
        'Query.HasPreset': requestParameters?.queryHasPreset
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritAdminQuerySettings(
    requestParameters?: MeritAdminQuerySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMeritSimulationSettings>;
  public meritAdminQuerySettings(
    requestParameters?: MeritAdminQuerySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMeritSimulationSettings>>;
  public meritAdminQuerySettings(
    requestParameters?: MeritAdminQuerySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMeritSimulationSettings>>;
  public meritAdminQuerySettings(
    requestParameters?: MeritAdminQuerySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('meritAdminQuerySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/merit`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.TargetTypeString': requestParameters?.queryTargetTypeString,
        'Query.SimulationId': requestParameters?.querySimulationId,
        'Query.Priority': requestParameters?.queryPriority,
        'Query.Title': requestParameters?.queryTitle,
        'Query.FixedAllocationPercentage': requestParameters?.queryFixedAllocationPercentage,
        'Query.FixedAllocationTotal': requestParameters?.queryFixedAllocationTotal,
        'Query.FixedAllocationCurrency': requestParameters?.queryFixedAllocationCurrency,
        'Query.FlexibleAllocationPercentage': requestParameters?.queryFlexibleAllocationPercentage,
        'Query.MinimumIncreasePercentage': requestParameters?.queryMinimumIncreasePercentage,
        'Query.MinimumIncreaseTotal': requestParameters?.queryMinimumIncreaseTotal,
        'Query.MinimumIncreaseCurrency': requestParameters?.queryMinimumIncreaseCurrency,
        'Query.UnrestrictedBudgetPercentage': requestParameters?.queryUnrestrictedBudgetPercentage,
        'Query.EffectiveDateMeritAt': requestParameters?.queryEffectiveDateMeritAt,
        'Query.EffectiveDateIncentiveAt': requestParameters?.queryEffectiveDateIncentiveAt,
        'Query.EffectiveDateOTPAt': requestParameters?.queryEffectiveDateOTPAt,
        'Query.IsPopulationExcluded': requestParameters?.queryIsPopulationExcluded,
        'Query.AffectedCount': requestParameters?.queryAffectedCount,
        'Query.Type': requestParameters?.queryType,
        'Query.AlreadyGrantedIncreaseCurrency': requestParameters?.queryAlreadyGrantedIncreaseCurrency,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritAdminUpdateAllocationValuesAllocations(
    requestParameters?: MeritAdminUpdateAllocationValuesAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IndividualAllocationValueModel>;
  public meritAdminUpdateAllocationValuesAllocations(
    requestParameters?: MeritAdminUpdateAllocationValuesAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IndividualAllocationValueModel>>;
  public meritAdminUpdateAllocationValuesAllocations(
    requestParameters?: MeritAdminUpdateAllocationValuesAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IndividualAllocationValueModel>>;
  public meritAdminUpdateAllocationValuesAllocations(
    requestParameters?: MeritAdminUpdateAllocationValuesAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('meritAdminUpdateAllocationValuesAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/values/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createOrReplaceIndividualAllocationValue,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritAdminUpdateManyRecords(
    requestParameters?: MeritAdminUpdateManyRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfRecordUpdateBatchMetadata>;
  public meritAdminUpdateManyRecords(
    requestParameters?: MeritAdminUpdateManyRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfRecordUpdateBatchMetadata>>;
  public meritAdminUpdateManyRecords(
    requestParameters?: MeritAdminUpdateManyRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfRecordUpdateBatchMetadata>>;
  public meritAdminUpdateManyRecords(
    requestParameters?: MeritAdminUpdateManyRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('meritAdminUpdateManyRecords', { seasonId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerGid: requestParameters?.lineManagerGid,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        State: requestParameters?.state,
        TemplateName: requestParameters?.templateName,
        TemplateType: requestParameters?.templateType,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        ExportedAt: requestParameters?.exportedAt,
        ExportedAtMax: requestParameters?.exportedAtMax,
        IsOtpOnly: requestParameters?.isOtpOnly,
        HasPreset: requestParameters?.hasPreset
      },
      body: requestParameters?.meritRecordsUpdateManyRecords,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritAdminUpdateSettings(
    requestParameters?: MeritAdminUpdateSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritSimulationSettings>;
  public meritAdminUpdateSettings(
    requestParameters?: MeritAdminUpdateSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritSimulationSettings>>;
  public meritAdminUpdateSettings(
    requestParameters?: MeritAdminUpdateSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritSimulationSettings>>;
  public meritAdminUpdateSettings(
    requestParameters?: MeritAdminUpdateSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const meritSettingsId = requestParameters?.meritSettingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('meritAdminUpdateSettings', { meritSettingsId, simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/merit/${this.configuration.encodeParam({ name: 'meritSettingsId', value: meritSettingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMeritSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pauseOrResumeMeritSeasonSeasons(
    requestParameters?: PauseOrResumeMeritSeasonSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public pauseOrResumeMeritSeasonSeasons(
    requestParameters?: PauseOrResumeMeritSeasonSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public pauseOrResumeMeritSeasonSeasons(
    requestParameters?: PauseOrResumeMeritSeasonSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public pauseOrResumeMeritSeasonSeasons(
    requestParameters?: PauseOrResumeMeritSeasonSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('pauseOrResumeMeritSeasonSeasons', { seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: [],
      query: { action: requestParameters?.action },
      body: requestParameters?.resumeOrPauseMeritSeason,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public promoteEmployeeAllocationMembers(
    requestParameters?: PromoteEmployeeAllocationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public promoteEmployeeAllocationMembers(
    requestParameters?: PromoteEmployeeAllocationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public promoteEmployeeAllocationMembers(
    requestParameters?: PromoteEmployeeAllocationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public promoteEmployeeAllocationMembers(
    requestParameters?: PromoteEmployeeAllocationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('promoteEmployeeAllocationMembers', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/promote`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.promoteEmployee,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAllocationMemberComments(
    requestParameters?: QueryAllocationMemberCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<AllocationComment>>;
  public queryAllocationMemberComments(
    requestParameters?: QueryAllocationMemberCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<AllocationComment>>>;
  public queryAllocationMemberComments(
    requestParameters?: QueryAllocationMemberCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<AllocationComment>>>;
  public queryAllocationMemberComments(
    requestParameters?: QueryAllocationMemberCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('queryAllocationMemberComments', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/values/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAllocationWorkflows(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<AllocationWorkflow>>;
  public queryAllocationWorkflows(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<AllocationWorkflow>>>;
  public queryAllocationWorkflows(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<AllocationWorkflow>>>;
  public queryAllocationWorkflows(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/allocations/workflows`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEquitySettings(
    requestParameters?: QueryEquitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEquitySettings>;
  public queryEquitySettings(
    requestParameters?: QueryEquitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEquitySettings>>;
  public queryEquitySettings(
    requestParameters?: QueryEquitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEquitySettings>>;
  public queryEquitySettings(requestParameters?: QueryEquitySettingsParams, ...args: RequestArgs): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryEquitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/equity`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.TargetTypeString': requestParameters?.queryTargetTypeString,
        'Query.SimulationId': requestParameters?.querySimulationId,
        'Query.Priority': requestParameters?.queryPriority,
        'Query.Title': requestParameters?.queryTitle,
        'Query.Description': requestParameters?.queryDescription,
        'Query.IsPopulationExcluded': requestParameters?.queryIsPopulationExcluded,
        'Query.AffectedCount': requestParameters?.queryAffectedCount,
        'Query.Type': requestParameters?.queryType,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEquitySubSettings(
    requestParameters?: QueryEquitySubSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<EquitySubSettingsModel>>;
  public queryEquitySubSettings(
    requestParameters?: QueryEquitySubSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<EquitySubSettingsModel>>>;
  public queryEquitySubSettings(
    requestParameters?: QueryEquitySubSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<EquitySubSettingsModel>>>;
  public queryEquitySubSettings(
    requestParameters?: QueryEquitySubSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const equitySettingsId = requestParameters?.equitySettingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryEquitySubSettings', { equitySettingsId, simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/equity/${this.configuration.encodeParam({ name: 'equitySettingsId', value: equitySettingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/sub-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesEquitySettings(
    requestParameters?: QueryFieldValuesEquitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesEquitySettings(
    requestParameters?: QueryFieldValuesEquitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesEquitySettings(
    requestParameters?: QueryFieldValuesEquitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesEquitySettings(
    requestParameters?: QueryFieldValuesEquitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryFieldValuesEquitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/equity/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        TargetTypeString: requestParameters?.targetTypeString,
        SimulationId: requestParameters?.simulationId2,
        Priority: requestParameters?.priority,
        Title: requestParameters?.title,
        Description: requestParameters?.description,
        IsPopulationExcluded: requestParameters?.isPopulationExcluded,
        AffectedCount: requestParameters?.affectedCount,
        Type: requestParameters?.type,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesIndividualMultiplierSettings(
    requestParameters?: QueryFieldValuesIndividualMultiplierSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesIndividualMultiplierSettings(
    requestParameters?: QueryFieldValuesIndividualMultiplierSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesIndividualMultiplierSettings(
    requestParameters?: QueryFieldValuesIndividualMultiplierSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesIndividualMultiplierSettings(
    requestParameters?: QueryFieldValuesIndividualMultiplierSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryFieldValuesIndividualMultiplierSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/individual-multiplier/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        TargetTypeString: requestParameters?.targetTypeString,
        SimulationId: requestParameters?.simulationId2,
        Priority: requestParameters?.priority,
        Title: requestParameters?.title,
        Description: requestParameters?.description,
        AffectedCount: requestParameters?.affectedCount,
        Type: requestParameters?.type,
        IsExcluded: requestParameters?.isExcluded,
        IsEditable: requestParameters?.isEditable,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesMeritIncentiveSettings(
    requestParameters?: QueryFieldValuesMeritIncentiveSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesMeritIncentiveSettings(
    requestParameters?: QueryFieldValuesMeritIncentiveSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesMeritIncentiveSettings(
    requestParameters?: QueryFieldValuesMeritIncentiveSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesMeritIncentiveSettings(
    requestParameters?: QueryFieldValuesMeritIncentiveSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryFieldValuesMeritIncentiveSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/incentive/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        TargetTypeString: requestParameters?.targetTypeString,
        SimulationId: requestParameters?.simulationId2,
        Priority: requestParameters?.priority,
        Title: requestParameters?.title,
        Description: requestParameters?.description,
        IsPopulationExcluded: requestParameters?.isPopulationExcluded,
        AffectedCount: requestParameters?.affectedCount,
        Type: requestParameters?.type,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryIndividualMultiplierSettings(
    requestParameters?: QueryIndividualMultiplierSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfIndividualMultiplierSettings>;
  public queryIndividualMultiplierSettings(
    requestParameters?: QueryIndividualMultiplierSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfIndividualMultiplierSettings>>;
  public queryIndividualMultiplierSettings(
    requestParameters?: QueryIndividualMultiplierSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfIndividualMultiplierSettings>>;
  public queryIndividualMultiplierSettings(
    requestParameters?: QueryIndividualMultiplierSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryIndividualMultiplierSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/individual-multiplier`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.TargetTypeString': requestParameters?.queryTargetTypeString,
        'Query.SimulationId': requestParameters?.querySimulationId,
        'Query.Priority': requestParameters?.queryPriority,
        'Query.Title': requestParameters?.queryTitle,
        'Query.Description': requestParameters?.queryDescription,
        'Query.AffectedCount': requestParameters?.queryAffectedCount,
        'Query.Type': requestParameters?.queryType,
        'Query.IsExcluded': requestParameters?.queryIsExcluded,
        'Query.IsEditable': requestParameters?.queryIsEditable,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMeritIncentiveSettings(
    requestParameters?: QueryMeritIncentiveSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMeritIncentiveSettings>;
  public queryMeritIncentiveSettings(
    requestParameters?: QueryMeritIncentiveSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMeritIncentiveSettings>>;
  public queryMeritIncentiveSettings(
    requestParameters?: QueryMeritIncentiveSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMeritIncentiveSettings>>;
  public queryMeritIncentiveSettings(
    requestParameters?: QueryMeritIncentiveSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryMeritIncentiveSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/incentive`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.TargetTypeString': requestParameters?.queryTargetTypeString,
        'Query.SimulationId': requestParameters?.querySimulationId,
        'Query.Priority': requestParameters?.queryPriority,
        'Query.Title': requestParameters?.queryTitle,
        'Query.Description': requestParameters?.queryDescription,
        'Query.IsPopulationExcluded': requestParameters?.queryIsPopulationExcluded,
        'Query.AffectedCount': requestParameters?.queryAffectedCount,
        'Query.Type': requestParameters?.queryType,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMeritIncentiveSubSettings(
    requestParameters?: QueryMeritIncentiveSubSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<MeritIncentiveSubSettingsModel>>;
  public queryMeritIncentiveSubSettings(
    requestParameters?: QueryMeritIncentiveSubSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<MeritIncentiveSubSettingsModel>>>;
  public queryMeritIncentiveSubSettings(
    requestParameters?: QueryMeritIncentiveSubSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<MeritIncentiveSubSettingsModel>>>;
  public queryMeritIncentiveSubSettings(
    requestParameters?: QueryMeritIncentiveSubSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const incentiveSettingsId = requestParameters?.incentiveSettingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryMeritIncentiveSubSettings', { incentiveSettingsId, simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/incentive/${this.configuration.encodeParam({ name: 'incentiveSettingsId', value: incentiveSettingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/sub-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTotalViewAllocationTotals(
    requestParameters?: QueryTotalViewAllocationTotalsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMeritAllocationMember>;
  public queryTotalViewAllocationTotals(
    requestParameters?: QueryTotalViewAllocationTotalsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMeritAllocationMember>>;
  public queryTotalViewAllocationTotals(
    requestParameters?: QueryTotalViewAllocationTotalsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMeritAllocationMember>>;
  public queryTotalViewAllocationTotals(
    requestParameters?: QueryTotalViewAllocationTotalsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('queryTotalViewAllocationTotals', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/total`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        PriorityEmployeeId: requestParameters?.priorityEmployeeId,
        ParentOrgCode: requestParameters?.parentOrgCode,
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.TargetTypeString': requestParameters?.queryTargetTypeString,
        'Query.MeritPopulation': requestParameters?.queryMeritPopulation,
        'Query.EquityPopulation': requestParameters?.queryEquityPopulation,
        'Query.ManagementGroup': requestParameters?.queryManagementGroup,
        'Query.PositionClass': requestParameters?.queryPositionClass,
        'Query.MercerJobCode': requestParameters?.queryMercerJobCode,
        'Query.OrgCluster': requestParameters?.queryOrgCluster,
        'Query.OrgClusterNode': requestParameters?.queryOrgClusterNode,
        'Query.GeoCluster': requestParameters?.queryGeoCluster,
        'Query.GeoClusterNode': requestParameters?.queryGeoClusterNode,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Gid': requestParameters?.queryGid,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.Are': requestParameters?.queryAre,
        'Query.Workflow': requestParameters?.queryWorkflow,
        'Query.IsFlagged': requestParameters?.queryIsFlagged,
        'Query.IsMeritExcluded': requestParameters?.queryIsMeritExcluded,
        'Query.IsIncentiveExcluded': requestParameters?.queryIsIncentiveExcluded,
        'Query.IsEquityExcluded': requestParameters?.queryIsEquityExcluded,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        impersonatedEmployee: requestParameters?.impersonatedEmployee
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateAllocationWorkflows(
    requestParameters?: RecalculateAllocationWorkflowsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfAllocationWorkflowRecalculationMetadata>;
  public recalculateAllocationWorkflows(
    requestParameters?: RecalculateAllocationWorkflowsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfAllocationWorkflowRecalculationMetadata>>;
  public recalculateAllocationWorkflows(
    requestParameters?: RecalculateAllocationWorkflowsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfAllocationWorkflowRecalculationMetadata>>;
  public recalculateAllocationWorkflows(
    requestParameters?: RecalculateAllocationWorkflowsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/allocations/workflows/recalculate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.recalculateAllocationWorkflow,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public refineMeritTasksSeasons(
    requestParameters?: RefineMeritTasksSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public refineMeritTasksSeasons(
    requestParameters?: RefineMeritTasksSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public refineMeritTasksSeasons(
    requestParameters?: RefineMeritTasksSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public refineMeritTasksSeasons(
    requestParameters?: RefineMeritTasksSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('refineMeritTasksSeasons', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/correct-tasks`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public resetEmployeePromotionAllocationMembers(
    requestParameters?: ResetEmployeePromotionAllocationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public resetEmployeePromotionAllocationMembers(
    requestParameters?: ResetEmployeePromotionAllocationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public resetEmployeePromotionAllocationMembers(
    requestParameters?: ResetEmployeePromotionAllocationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public resetEmployeePromotionAllocationMembers(
    requestParameters?: ResetEmployeePromotionAllocationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('resetEmployeePromotionAllocationMembers', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/reset-promotion`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setMeritSeasonToPayrollAndLetterStateSeasons(
    requestParameters?: SetMeritSeasonToPayrollAndLetterStateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfIMetadata>;
  public setMeritSeasonToPayrollAndLetterStateSeasons(
    requestParameters?: SetMeritSeasonToPayrollAndLetterStateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public setMeritSeasonToPayrollAndLetterStateSeasons(
    requestParameters?: SetMeritSeasonToPayrollAndLetterStateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public setMeritSeasonToPayrollAndLetterStateSeasons(
    requestParameters?: SetMeritSeasonToPayrollAndLetterStateSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('setMeritSeasonToPayrollAndLetterStateSeasons', { seasonId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/set-to-payroll-and-letter`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setWasPromotedAllocationMembers(
    requestParameters?: SetWasPromotedAllocationMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public setWasPromotedAllocationMembers(
    requestParameters?: SetWasPromotedAllocationMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public setWasPromotedAllocationMembers(
    requestParameters?: SetWasPromotedAllocationMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public setWasPromotedAllocationMembers(
    requestParameters?: SetWasPromotedAllocationMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('setWasPromotedAllocationMembers', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/was-promoted`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.setWasPromotedForAllocationMember,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateRuleAllocationWorkflows(
    requestParameters?: SimulateRuleAllocationWorkflowsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public simulateRuleAllocationWorkflows(
    requestParameters?: SimulateRuleAllocationWorkflowsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public simulateRuleAllocationWorkflows(
    requestParameters?: SimulateRuleAllocationWorkflowsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public simulateRuleAllocationWorkflows(
    requestParameters?: SimulateRuleAllocationWorkflowsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('simulateRuleAllocationWorkflows', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/allocations/workflows/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateRuleIndividualMultiplierSettings(
    requestParameters?: SimulateRuleIndividualMultiplierSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public simulateRuleIndividualMultiplierSettings(
    requestParameters?: SimulateRuleIndividualMultiplierSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public simulateRuleIndividualMultiplierSettings(
    requestParameters?: SimulateRuleIndividualMultiplierSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public simulateRuleIndividualMultiplierSettings(
    requestParameters?: SimulateRuleIndividualMultiplierSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('simulateRuleIndividualMultiplierSettings', { id, simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/individual-multiplier/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public startCalculationSingleCalculation(
    requestParameters?: StartCalculationSingleCalculationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<string>;
  public startCalculationSingleCalculation(
    requestParameters?: StartCalculationSingleCalculationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<string>>;
  public startCalculationSingleCalculation(
    requestParameters?: StartCalculationSingleCalculationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<string>>;
  public startCalculationSingleCalculation(
    requestParameters?: StartCalculationSingleCalculationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('startCalculationSingleCalculation', { seasonId, simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/calculate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.meritSingleCalculationCommand,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public transferCompensationOverlaysSeasons(
    requestParameters?: TransferCompensationOverlaysSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfCompensationOverlayTransferMetadata>;
  public transferCompensationOverlaysSeasons(
    requestParameters?: TransferCompensationOverlaysSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfCompensationOverlayTransferMetadata>>;
  public transferCompensationOverlaysSeasons(
    requestParameters?: TransferCompensationOverlaysSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfCompensationOverlayTransferMetadata>>;
  public transferCompensationOverlaysSeasons(
    requestParameters?: TransferCompensationOverlaysSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('transferCompensationOverlaysSeasons', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/compensation-overlay`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public transferMercerDataSeasons(
    requestParameters?: TransferMercerDataSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfMercerDataTransferMetadata>;
  public transferMercerDataSeasons(
    requestParameters?: TransferMercerDataSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfMercerDataTransferMetadata>>;
  public transferMercerDataSeasons(
    requestParameters?: TransferMercerDataSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfMercerDataTransferMetadata>>;
  public transferMercerDataSeasons(
    requestParameters?: TransferMercerDataSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('transferMercerDataSeasons', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/mercer-data`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public triggerNewHireProcessAllocations(
    requestParameters?: TriggerNewHireProcessAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfNewHireTotalProcessMetadata>;
  public triggerNewHireProcessAllocations(
    requestParameters?: TriggerNewHireProcessAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfNewHireTotalProcessMetadata>>;
  public triggerNewHireProcessAllocations(
    requestParameters?: TriggerNewHireProcessAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfNewHireTotalProcessMetadata>>;
  public triggerNewHireProcessAllocations(
    requestParameters?: TriggerNewHireProcessAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/new-hire-process`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.triggerNewHireProcess,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateAllocationSettingsAllocationSettings(
    requestParameters?: UpdateAllocationSettingsAllocationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<AllocationSettings>;
  public updateAllocationSettingsAllocationSettings(
    requestParameters?: UpdateAllocationSettingsAllocationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<AllocationSettings>>;
  public updateAllocationSettingsAllocationSettings(
    requestParameters?: UpdateAllocationSettingsAllocationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<AllocationSettings>>;
  public updateAllocationSettingsAllocationSettings(
    requestParameters?: UpdateAllocationSettingsAllocationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('updateAllocationSettingsAllocationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/merit-allocation-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateAllocationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateAllocationWorkflows(
    requestParameters?: UpdateAllocationWorkflowsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<AllocationWorkflow>;
  public updateAllocationWorkflows(
    requestParameters?: UpdateAllocationWorkflowsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<AllocationWorkflow>>;
  public updateAllocationWorkflows(
    requestParameters?: UpdateAllocationWorkflowsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<AllocationWorkflow>>;
  public updateAllocationWorkflows(
    requestParameters?: UpdateAllocationWorkflowsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateAllocationWorkflows', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/allocations/workflows/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateAllocationWorkflow,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEquitySettings(
    requestParameters?: UpdateEquitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EquitySettingsModel>;
  public updateEquitySettings(
    requestParameters?: UpdateEquitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EquitySettingsModel>>;
  public updateEquitySettings(
    requestParameters?: UpdateEquitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EquitySettingsModel>>;
  public updateEquitySettings(requestParameters?: UpdateEquitySettingsParams, ...args: RequestArgs): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const id = requestParameters?.id;
    this.checkRequired('updateEquitySettings', { simulationId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/equity/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEquitySettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEquitySubSettings(
    requestParameters?: UpdateEquitySubSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EquitySubSettingsModel>;
  public updateEquitySubSettings(
    requestParameters?: UpdateEquitySubSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EquitySubSettingsModel>>;
  public updateEquitySubSettings(
    requestParameters?: UpdateEquitySubSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EquitySubSettingsModel>>;
  public updateEquitySubSettings(
    requestParameters?: UpdateEquitySubSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('updateEquitySubSettings', { id, simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/equity/sub-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEquitySubSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEquityTypeEquitySubSettings(
    requestParameters?: UpdateEquityTypeEquitySubSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EquitySubSettingsModel>;
  public updateEquityTypeEquitySubSettings(
    requestParameters?: UpdateEquityTypeEquitySubSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EquitySubSettingsModel>>;
  public updateEquityTypeEquitySubSettings(
    requestParameters?: UpdateEquityTypeEquitySubSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EquitySubSettingsModel>>;
  public updateEquityTypeEquitySubSettings(
    requestParameters?: UpdateEquityTypeEquitySubSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('updateEquityTypeEquitySubSettings', { id, simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/equity/sub-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/equity-type`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEquitySubSettingsEquityType,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateIndividualMultiplierSettings(
    requestParameters?: UpdateIndividualMultiplierSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IndividualMultiplierSettingsModel>;
  public updateIndividualMultiplierSettings(
    requestParameters?: UpdateIndividualMultiplierSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IndividualMultiplierSettingsModel>>;
  public updateIndividualMultiplierSettings(
    requestParameters?: UpdateIndividualMultiplierSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IndividualMultiplierSettingsModel>>;
  public updateIndividualMultiplierSettings(
    requestParameters?: UpdateIndividualMultiplierSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId2 = requestParameters?.simulationId2;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('updateIndividualMultiplierSettings', { simulationId2 });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId2', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/individual-multiplier`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { simulationId: requestParameters?.simulationId },
      body: requestParameters?.updateIndividualMultiplierSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMeritIncentiveSettings(
    requestParameters?: UpdateMeritIncentiveSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritIncentiveSettingsModel>;
  public updateMeritIncentiveSettings(
    requestParameters?: UpdateMeritIncentiveSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritIncentiveSettingsModel>>;
  public updateMeritIncentiveSettings(
    requestParameters?: UpdateMeritIncentiveSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritIncentiveSettingsModel>>;
  public updateMeritIncentiveSettings(
    requestParameters?: UpdateMeritIncentiveSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const id = requestParameters?.id;
    this.checkRequired('updateMeritIncentiveSettings', { simulationId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/incentive/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMeritIncentiveSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMeritIncentiveSubSettings(
    requestParameters?: UpdateMeritIncentiveSubSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritIncentiveSubSettingsModel>;
  public updateMeritIncentiveSubSettings(
    requestParameters?: UpdateMeritIncentiveSubSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritIncentiveSubSettingsModel>>;
  public updateMeritIncentiveSubSettings(
    requestParameters?: UpdateMeritIncentiveSubSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritIncentiveSubSettingsModel>>;
  public updateMeritIncentiveSubSettings(
    requestParameters?: UpdateMeritIncentiveSubSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('updateMeritIncentiveSubSettings', { id, simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/seasons/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/incentive/sub-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMeritIncentiveSubSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePromotionDateSettingPromotionSetting(
    requestParameters?: UpdatePromotionDateSettingPromotionSettingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritPromotionDateSettingModel>;
  public updatePromotionDateSettingPromotionSetting(
    requestParameters?: UpdatePromotionDateSettingPromotionSettingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritPromotionDateSettingModel>>;
  public updatePromotionDateSettingPromotionSetting(
    requestParameters?: UpdatePromotionDateSettingPromotionSettingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritPromotionDateSettingModel>>;
  public updatePromotionDateSettingPromotionSetting(
    requestParameters?: UpdatePromotionDateSettingPromotionSettingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('updatePromotionDateSettingPromotionSetting', { seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/promotion-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.setPromotionDateSettingsCommand,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
